import StoreInitializer from './components/initializers/StoreInitializer'
import ErrorBoundary from './components/error_boundary/ErrorBoundary'
import '@xyflow/react/dist/style.css'
import './styles/badge-filter.scss'
import './styles/cards.scss'
import './styles/charts.scss'
import './styles/layout.scss'
import './styles/root.scss'
import './styles/spotlight.scss'
import './styles/smart-table.scss'
import './styles/overrides.scss'
import './styles/contract-editor.scss'
import './styles/loaders.scss'
import './styles/flow.scss'
import './styles/christmas.scss'
import './styles/report-builder.scss'

function App() {
    return (
        <ErrorBoundary>
            <StoreInitializer />
        </ErrorBoundary>
    )
}

export default App
